"use client";

import * as React from "react";
import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from "next-themes";

type DefaultThemeProviderProps = Omit<ThemeProviderProps, "children">;

/** Props padrão alinhadas ao App Router + Tailwind (classe `.dark` em globals.css). */
export const defaultThemeProviderProps = {
  attribute: "class",
  defaultTheme: "system",
  enableSystem: true,
  disableTransitionOnChange: true,
  /** Evita `style.colorScheme` no `<html>`, fonte comum de hydration mismatch. */
  enableColorScheme: false,
} satisfies DefaultThemeProviderProps;

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider {...defaultThemeProviderProps} {...props}>
      {children}
    </NextThemesProvider>
  );
}
